import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: {},
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            ...(sort && { sort })
        }).toString();
        let data  = await client.get('fichier-expert/page?' + queryParams);
        commit("SET_ALL", data.data);
        return data.data;
    },
    async getOne(cxt, id) {
        let data = await client.get('fichier-expert/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('fichier-expert/edit/' + payload.id, payload) : await client.post('fichier-expert/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('fichier-expert/delete/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async uploadFile({ commit }, { payload }) {
        try {
            const data = await client.post('fichier/upload', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            commit('SET_FICHIER', data);
            return data;
        } catch (error) {
            console.error('Erreur lors de l\'upload du fichier :', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

